// eslint-disable-next-line no-unused-vars -- just so the styles are included
import Footer from 'shared/storefront/Footer.svelte'

export default () => {}
